import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchOfferBanner } from "../../lib/api";

const DEFAULT_OFFER_ITEMS = [
  "Dussehra Festival Offer — Flat 15% OFF",
  "On all authentic handloom Ilkal sarees",
  "Free shipping above ₹1,999",
  "COD available across India",
  "Limited festive period only",
];

export const OfferBanner = () => {
  const [items, setItems] = useState(DEFAULT_OFFER_ITEMS);

  useEffect(() => {
    fetchOfferBanner()
      .then((data) => {
        if (data?.items?.length) setItems(data.items);
      })
      .catch(() => {});
  }, []);

  return (
    <section className="mt-4 sm:mt-6" data-testid="offer-banner-section">
      <Link to="/shop" data-testid="offer-banner-btn" className="block relative w-full overflow-hidden bg-gold border-y border-gold-dark/40 group">
        <div className="absolute inset-y-0 w-1/4 bg-gradient-to-r from-transparent via-ivory/40 to-transparent animate-shine pointer-events-none" />
        <div className="flex whitespace-nowrap animate-marquee w-max py-2.5 group-hover:[animation-play-state:paused]">
          {[...items, ...items, ...items].map((text, i) => (
            <span key={i} className="inline-flex items-center text-[11px] sm:text-xs tracking-[0.2em] uppercase font-semibold text-maroon-dark">
              <span className="mx-7">{text}</span>
              <span className="text-maroon/60">✦</span>
            </span>
          ))}
        </div>
      </Link>
    </section>
  );
};
